import React from 'react'
import { Hr, ModuleHeader } from '../../styles/dashboard'
import { Input } from '../input'
import AnnouncementItem from './announcement-item'
import { AnnouncementCardWrapper, AnnouncementCardTopSection, InputContainer } from './dashboard-announcements.style'
import { SelectContainer } from "../dashboard-overview/dashboard-overview.style";
import { MdSearch } from 'react-icons/md'



const Announcements = ({ search, scroll }) => {
    return (
        <div>
            {/* <ModuleHeader>
                <span>Announcements</span>
                <Hr />
            </ModuleHeader> */}
            <AnnouncementCardWrapper scroll={scroll}>
                {search ? (
                    <AnnouncementCardTopSection>
                        <InputContainer>
                            <Input
                                startAdornment={<MdSearch />}
                                placeholder='Search'
                                className="search"
                            />
                        </InputContainer>

                        <SelectContainer style={{ marginLeft: 'auto' }}>
                            <select>
                                <option value="">Sort by</option>
                                <option value="date">Date</option>
                                <option value="time">Time</option>
                                <option value="day">Day</option>
                            </select>
                        </SelectContainer>
                    </AnnouncementCardTopSection>
                ) : null}
                <AnnouncementItem />
                <AnnouncementItem />
                <AnnouncementItem />
                <AnnouncementItem />
                <AnnouncementItem />
            </AnnouncementCardWrapper>
        </div>
    )
}

export { Announcements }
